// Utility to map controls between different frameworks
// This is a simplified mapping between NIST 800-53 Rev 5 and ISO 27001 (2022)

export const controlMappings = {
  // NIST to ISO mappings
  'NIST_TO_ISO': {
    // Network Domain
    'AC-3': ['A.8.3'], // Access Enforcement to Information access restriction
    'AC-4': ['A.8.20', 'A.8.22'], // Information Flow to Networks security & Segregation of networks
    'AC-17': ['A.8.5'], // Remote Access to Secure Authentication
    'AC-18': ['A.8.20'], // Wireless Access to Networks security
    'AC-20': ['A.8.3'], // Use of External Systems to Information access restriction
    'SC-3': ['A.8.22'], // Security Function Isolation to Segregation of networks
    'SC-5': ['A.8.6'], // Denial of Service Protection to Capacity management
    'SC-7': ['A.8.20', 'A.8.22'], // Boundary Protection to Networks security & Segregation
    'SC-8': ['A.8.24'], // Transmission Confidentiality to Use of cryptography
    'SC-10': ['A.8.5'], // Network Disconnect to Secure authentication
    'SC-12': ['A.8.24'], // Cryptographic Key Management to Use of cryptography
    'SC-13': ['A.8.24'], // Cryptographic Protection to Use of cryptography
    'SC-20': ['A.8.20'], // Secure Name/Address Resolution to Networks security
    'SC-23': ['A.8.5'], // Session Authenticity to Secure authentication
    'SC-39': ['A.8.31'], // Process Isolation to Separation of environments
    'SC-40': ['A.8.20'], // Wireless Link Protection to Networks security
    'SI-2': ['A.8.8'], // Flaw Remediation to Management of technical vulnerabilities
    'SI-3': ['A.8.7'], // Malicious Code Protection to Protection against malware
    'SI-4': ['A.8.16'], // Information System Monitoring to Monitoring activities
    'SI-5': ['A.8.8'], // Security Alerts to Management of technical vulnerabilities
    'SI-7': ['A.8.9', 'A.8.15'], // Software Integrity to Configuration management & Logging
    
    // Identity Domain
    'AC-2': ['A.8.2', 'A.8.3'], // Account Management to Privileged access rights & access restriction
    'AC-6': ['A.8.2'], // Least Privilege to Privileged access rights
    'AC-11': ['A.8.5'], // Session Lock to Secure authentication
    'AC-12': ['A.8.5'], // Session Termination to Secure authentication
    'IA-2': ['A.8.5'], // User Identification and Authentication to Secure authentication
    'IA-3': ['A.8.1'], // Device Identification and Authentication to User endpoint devices
    'IA-4': ['A.8.5'], // Identifier Management to Secure authentication
    'IA-5': ['A.8.5'], // Authenticator Management to Secure authentication
    'IA-8': ['A.8.5'], // Non-Organization Users to Secure authentication
    'IA-11': ['A.8.5'], // Re-authentication to Secure authentication
    
    // Infrastructure Domain
    'AC-19': ['A.8.1'], // Mobile Devices to User endpoint devices
    'CM-2': ['A.8.9'], // Baseline Configuration to Configuration management
    'CM-6': ['A.8.9'], // Configuration Settings to Configuration management
    'CM-7': ['A.8.9'], // Least Functionality to Configuration management
    'CM-8': ['A.8.9'], // System Component Inventory to Configuration management
    'SC-28': ['A.8.24'], // Protection of Information at Rest to Use of cryptography
    'SC-37': ['A.8.20', 'A.8.22'], // Out-of-Band Channels to Network security & Segregation
    'SI-14': ['A.8.31'], // Non-Persistence to Separation of environments
    
    // Application Domain
    'AU-2': ['A.8.15'], // Audit Events to Logging
    'AU-6': ['A.8.16'], // Audit Review to Monitoring Activities
    'AU-9': ['A.8.15'], // Protection of Audit Information to Logging
    // 'CM-7' already mapped in the Network domain block above (identical target) — de-duplicated.
    'SA-3': ['A.8.25'], // System Development Life Cycle to Secure development life cycle
    'SA-4': ['A.8.26'], // Acquisition Process to Application security requirements
    'SA-8': ['A.8.27'], // Security Engineering Principles to Secure system architecture
    'SA-9': ['A.5.19'], // External System Services to Information security in supplier relationships
    'SA-10': ['A.8.25', 'A.8.9'], // Developer Config Management to Secure development & Config management
    'SA-11': ['A.8.29'], // Developer Testing to Security testing in development
    'SA-15': ['A.8.25'], // Development Process to Secure development life cycle
    'SA-17': ['A.8.27'], // Developer Security Architecture to Secure system architecture
    'SC-18': ['A.8.28'], // Mobile Code to Secure coding
    'SC-35': ['A.8.7'], // External Malicious Code to Protection against malware
    'SC-36': ['A.8.14'], // Distributed Processing to Redundancy of information processing
    'SI-10': ['A.8.28'], // Information Input Validation to Secure coding
  },
  
  // ISO to NIST mappings (reverse of the above)
  'ISO_TO_NIST': {
    // Network Domain
    'A.8.3': ['AC-3', 'AC-20'], // Information access restriction
    'A.8.5': ['AC-17', 'SC-10', 'SC-23', 'AC-11', 'AC-12', 'IA-2', 'IA-4', 'IA-5', 'IA-8', 'IA-11'], // Secure Authentication
    'A.8.6': ['SC-5'], // Capacity management
    'A.8.7': ['SI-3', 'SC-35'], // Protection against malware
    'A.8.8': ['SI-2', 'SI-5'], // Management of technical vulnerabilities
    'A.8.9': ['SI-7', 'CM-2', 'CM-6', 'CM-7', 'CM-8'], // Configuration management
    'A.8.15': ['SI-7', 'AU-2', 'AU-9'], // Logging
    'A.8.16': ['SI-4', 'AU-6'], // Monitoring activities
    'A.8.20': ['AC-4', 'AC-18', 'SC-7', 'SC-20', 'SC-40', 'SC-37'], // Networks security
    'A.8.22': ['AC-4', 'SC-3', 'SC-7', 'SC-37'], // Segregation of networks
    'A.8.24': ['SC-8', 'SC-12', 'SC-13', 'SC-28'], // Use of cryptography
    'A.8.31': ['SC-39', 'SI-14'], // Separation of environments
    
    // Identity Domain
    'A.8.1': ['IA-3', 'AC-19'], // User endpoint devices
    'A.8.2': ['AC-2', 'AC-6'], // Privileged access rights
    
    // Application Domain
    'A.8.14': ['SC-36'], // Redundancy of information processing
    'A.8.25': ['SA-3', 'SA-10', 'SA-15'], // Secure development life cycle
    'A.8.26': ['SA-4'], // Application security requirements
    'A.8.27': ['SA-8', 'SA-17'], // Secure system architecture
    'A.8.28': ['SC-18', 'SI-10'], // Secure coding
    'A.8.29': ['SA-11'], // Security testing in development
    
    // Organizational Controls
    'A.5.19': ['SA-9'], // Information security in supplier relationships
  }
};

// Function to find mapped controls between frameworks
export const findMappedControls = (controlId, sourceFramework) => {
  // Determine which mapping to use
  const mappingKey = sourceFramework === 'NIST 800-53 Rev 5' ? 'NIST_TO_ISO' : 'ISO_TO_NIST';
  
  // Return the mapped controls or an empty array if no mapping exists
  return controlMappings[mappingKey][controlId] || [];
};
